import styled from 'styled-components';
import {device} from '../../styled/device';

export const Content = styled.div`
  display: grid;
  font-size: 16px;
  grid-auto-flow: column;
  grid-column-gap: 90px;
  grid-template-columns: 7fr 5fr;
  grid-template-rows: auto auto auto;
  text-align: center;
  position: relative;
  grid-template-areas:
    'Form Summary'
    'Invoicing Summary';

  & .paymentForm {
    grid-area: Form;
  }

  & .invoicingDetails {
    grid-area: Invoicing;
  }

  & .summary {
    grid-area: Summary;
  }

  @media (max-width: ${device.tablet}) {
    padding-bottom: 100px;
    grid-template-columns: 1fr;
    grid-template-areas:
      'Summary'
      'Form'
      'Invoicing';
  }
`;

export const CardNumberElementWrapper = styled.div`
width: 100%;
outline: none;
margin: 0;
font-family: inherit;
font-size: 16px;
transition: background-color 0.25s ease-in-out, border-color 0.05s ease-in-out;
color: #353945;
padding: 0 16px 0 7px;
box-sizing: border-box;
border-radius: 7px;
border: 1px solid #a2a2b4;
height: 50px; }
.input.invalid {
  border-color: #F84B7A; }
.input::placeholder {
  font-family: inherit;
  color: #9696B9;
  opacity: 1; }
.input::-webkit-inner-spin-button, .input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  -moz-appearance: textfield; 
`;
